import { PredefinedPayloadExtractor } from '../../../redux/list/list-payload-extractor';
import {
  appendNewItem,
  removeItem,
  updateItemByKey,
} from '../../../redux/list/list-update.reducer';
import {
  createDefaultListState,
  createListReducer,
  ListState,
} from '../../../redux/list/list.reducer';
import { CallApiSuccessResponse } from '../../../redux/middlewares/call-api/call-api';
import { Action, Reducer } from '../../../redux/redux.types';
import { Replication } from '../replications.types';

import { REPLICATIONS_LIST_ACTION_NAMES } from './replications-list.actions';

export type ReplicationsListState = ListState<Replication>;

const defaultState: ReplicationsListState =
  createDefaultListState<Replication>();

const listReducer: Reducer<ReplicationsListState> = createListReducer({
  actionNames: [
    REPLICATIONS_LIST_ACTION_NAMES.GET_REPLICATIONS_START,
    REPLICATIONS_LIST_ACTION_NAMES.GET_REPLICATIONS_SUCCESS,
    REPLICATIONS_LIST_ACTION_NAMES.GET_REPLICATIONS_ERROR,
  ],
  payloadExtractorOptions: PredefinedPayloadExtractor.CallApi,
  key: 'id',
});

export const replicationsList = (
  state: ReplicationsListState = defaultState,
  action: Action,
): ReplicationsListState => {
  const listState: ReplicationsListState = listReducer(state, action);

  switch (action.type) {
    case REPLICATIONS_LIST_ACTION_NAMES.CREATE_SUCCESS:
    case REPLICATIONS_LIST_ACTION_NAMES.DUPLICATE_REPLICATION_SUCCESS: {
      const { rawResponse }: CallApiSuccessResponse<Replication> =
        action.payload;
      return appendNewItem(listState, rawResponse, 'id');
    }

    case REPLICATIONS_LIST_ACTION_NAMES.CHANGE_REPLICATION_ACTIVE_STATUS_SUCCESS: {
      const { enabled, replicationId } = action.payload.additionalData;

      return updateItemByKey<Replication>(
        listState,
        (replication) => ({ ...replication, enabled }),
        replicationId,
      );
    }

    case REPLICATIONS_LIST_ACTION_NAMES.UPDATE_REPLICATION_SUCCESS: {
      const replication = action.payload;
      const { replicationId } = action.meta;

      return updateItemByKey<Replication>(
        listState,
        () => replication,
        replicationId,
      );
    }

    case REPLICATIONS_LIST_ACTION_NAMES.RENAME_REPLICATION_SUCCESS: {
      const { replicationId, newName } = action.payload.additionalData;

      return updateItemByKey<Replication>(
        listState,
        (replication) => ({ ...replication, name: newName }),
        replicationId,
      );
    }

    case REPLICATIONS_LIST_ACTION_NAMES.REMOVE_REPLICATION_SUCCESS: {
      const { replicationId } = action.payload.additionalData;
      return removeItem(listState, replicationId);
    }

    default:
      return listState;
  }
};
